import checkSpeechToTextUser from "@custom/rtk-apis/speechToText/checkSpeechToTextUser";
import { createSlice } from "@reduxjs/toolkit";

export interface checkSpeechToTextState {
  data: any;
  status: string;
  loading: boolean;
  msg: string | null;
}

const initialState: checkSpeechToTextState = {
  data: [],
  status: '',
  loading: false,
  msg: null,
};

const checkSpeechToTextUserSlice = createSlice({
  name: 'checkSpeechToTextUser',
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkSpeechToTextUser.pending, (state) => {
        state.loading = true;
        state.status = 'pending';
        state.msg = null;
      })
      .addCase(checkSpeechToTextUser.fulfilled, (state, {payload}) => {
        state.data = payload?.result;
        state.loading = false;
        state.status = payload?.status;
        state.msg = payload?.msg;
      })
      .addCase(checkSpeechToTextUser.rejected, (state, {payload}) => {
        state.data = [];
        state.loading = false;
        state.status = 'failure';
        state.msg = typeof payload === 'string' ? payload : 'Failed to check Speech to text users data.';
      });
  }
});

export default checkSpeechToTextUserSlice.reducer;
export const { closeModal } = checkSpeechToTextUserSlice.actions;
